import { IconInfoCircle } from '@tabler/icons-react';
import React from 'react';

import styled, { css } from 'styled-components';

import { LinkButton } from 'brand-guidelines/Buttons-styled-components';
import { BRAND_COLORS } from 'brand-guidelines/colors';
import { commonInputStyles, FormInputProps } from 'brand-guidelines/input-styled-components';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { Alert } from 'pages/checkout/steps/Insurance/Alert';
import { ALERT_THEMES } from 'pages/checkout/steps/Insurance/Alert-styled-components';
import { AlignItems, FlexDirection, JustifyContent } from 'types/CSS';

import { BaseBodyText } from './typographic-styled-components';

export const CheckoutLinkButton = styled(LinkButton)`
  ${TYPOGRAPHY.CIRCULAR.bold}
  color: ${BRAND_COLORS.darkGreen};
`;

export const CheckoutLink = styled(CheckoutLinkButton).attrs({ as: 'a' })`
  text-align: center;
`;

interface FormLabelProps {
  $direction?: FlexDirection;
  $alignItems?: AlignItems;
  $justifyContent?: JustifyContent;
}

export const FormLabel = styled.label<FormLabelProps>`
  ${TYPOGRAPHY.CIRCULAR.bold}
  color: ${BRAND_COLORS.black};
  font-size: 14px;
  line-height: 21px;

  display: flex;
  gap: 8px;
  ${({ $direction = FlexDirection.COLUMN }) => $direction && css`
    flex-direction: ${$direction};
  `}
  ${({ $alignItems }) => $alignItems && css`
    align-items: ${$alignItems};
  `}
  ${({ $justifyContent }) => $justifyContent && css`
    justify-content: ${$justifyContent};
  `}
`;

export const FormInput = styled.input<FormInputProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  ${commonInputStyles}

  &::placeholder {
    color: ${BRAND_COLORS.darkStroke};
  }
`;

export const FormTextarea = styled(FormInput).attrs({ as: 'textarea' })`
  height: 80px;
  resize: none;
`;

export const ErrorMessage = styled(BaseBodyText)`
  color: ${BRAND_COLORS.darkRed};
  font-size: 12px;
  line-height: 20px;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FormError = styled(Alert).attrs({
  theme: ALERT_THEMES.error,
  customIcon: <IconInfoCircle />,
})``;
